export default {
  // ページコントロール
  SET_ACTIVE_SUB_PAGE: 'recipientMasterSetActiveSubPage',
  SET_ACTIVE_THIRD_PAGE: 'recipientMasterSetActiveThirdPage',

  // 送信先マスタコントロール
  INITIALIZE_RECIPIENT_MASTER_OPTIONS: 'recipientMasterInitializeRecipientMasterOptions',
  SELECT_RECIPIENT_MASTER: 'recipientMasterSelectRecipientMaster',
  DELETE_RECIPIENT_MASTER: 'recipientMasterDeleteRecipientMaster',
  CHANGE_RECIPIENT_MASTER_NAME: 'recipientMasterChangeRecipientMasterName',
  CREATE_RECIPIENT_MASTER: 'recipientMasterCreateRecipientMaster',
  UPDATE_RECIPIENT_MASTER_LIST: 'recipientMasterUpdateRecipientMasterList',

  // フォルダコントロール
  SET_FOLDER_LIST: 'recipientMasterSetFolderList',

  //登録確認ダイアログ
  SET_CORPORATE_NUMBER_ADD_SUBMIT_MODAL: 'setCorporateNumberAddSubmitModal',
  SET_SUBMIT_FLAG: 'setSubmitFlag',
  //STEP1 法人新規登録
  SET_NEW_CORPORATE_NUMBER: 'setNewCorporateNumber',
  SET_NEW_CORPORATE_NAME: 'setNewCorporateName',
  SET_RECIPIENT_DETAIL_ID: 'setRecipientDetailId',
  //選択された法人番号、法人名
  SET_SELECTED_CORPORATE_NUMBER: 'setSelectedCorporateNumber',
  SET_SELECTED_CORPORATE_NAME: 'setSelectedCorporateName',
  //STEP2 取引先新規登録
  SET_IS_FIRST_CLIENT: 'setIsFirstClient',
  SET_NEW_CLIENT_CODE: 'setNewClientCode',
  SET_NEW_CLIENT_NAME: 'setNewClientName',
  SET_SELECTED_CLIENT_CODE: 'setSelectedClientCode',
  SET_SELECTED_CLIENT_NAME: 'setSelectedClientName',
  //STEP3 担当者新規登録
  SET_NEW_RECIPIENT_USER_NAME: 'setNewRecipientUserName',
  SET_NEW_RECIPIENT_DEPARTMENT_NAME: 'setNewRecipientDepartmentName',
  SET_NEW_RECIPIENT_MAIL: 'setNewRecipientMail',
}
